// @flow

import * as React from 'react';
import {useContext, useMemo} from 'react';
import {ApiRequestExecutor} from './ApiRequestExecutor';
import {ApiClient} from './generated/ApiClient';

type ApiContextType = {
  api: ApiClient,
};

const ApiContext = React.createContext<ApiContextType>({
  api: ({}: any),
});

type ApiProviderProps = {
  children?: React.Node,
  baseUrl: string,
  csrfToken: string,
  routeMap: {[endpoint: string]: string},
};

export const ApiProvider = (props: ApiProviderProps) => {
  const api = useMemo(() => {
    const executor = new ApiRequestExecutor(
      props.baseUrl,
      props.csrfToken,
      props.routeMap,
    );
    return new ApiClient(executor);
  }, [props.baseUrl, props.csrfToken, props.routeMap]);

  const context = {api};

  return (
    <ApiContext.Provider value={context}>{props.children}</ApiContext.Provider>
  );
};

export const useApi = () => {
  return useContext(ApiContext);
};
